// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import { xBaseTheme } from "@keller/XDL/types";
import color from "@keller/XDL/Utilities/color";
import { css } from "styled-components";

export const buttonTransparent = css`
    &,
    &:focus:not([disabled]),
    &:active:not([disabled]),
    &:disabled,
    &:focus:hover,
    &:hover:not(:disabled) {
        border: 0;
        background-color: transparent;
        box-shadow: none;
        outline: 0;
        transform: translate(0, 0);
        min-height: initial;
    }
`;

export default {
    primary: {
        mergeCss: true,
        ...ButtonPresentationPropsDefault,
        color: "primary",
        buttonType: "solid",
        shape: "rounded",
        css: css`
            outline: none;
            border-color: transparent;
            border-radius: 2px;
            box-sizing: border-box;
            border-width: 1px;

            &:hover:not(:disabled) {
                background: ${color("common.ui1")};
                border-color: transparent;
            }
            &:disabled {
                opacity: 0.5;
                box-shadow: none;
                background: ${color("primary", 0.33)};
                border-color: transparent;
            }
            &:focus:not(:disabled),
            &:active:not(:disabled) {
                outline: none;
                background: ${color("common.ui2")};
                border-color: transparent;
            }
        `,
    },
    secondary: {
        ...ButtonPresentationPropsDefault,
        color: "transparent",
        buttonType: "solid",
        shape: "rounded",
        css: css`
            outline: none;
            border-color: ${color("primary")};
            background-color: ${color("common.white")};
            font-weight: bold;
            color: ${color("primary")};
            border-radius: 2px;
            border-width: 1px;
            &:hover:not(:disabled) {
                border-color: ${color("common.ui1")};
                color: ${color("common.ui1")};
                background-color: ${color("common.white")};
            }
            &:disabled {
                opacity: 0.5;
                box-shadow: none;
                border-color: ${color("primary", 0.33)};
                color: ${color("primary", 0.33)};
                background-color: ${color("common.white")};
            }
            &:focus:not(:disabled),
            &:active:not(:disabled) {
                outline: none;
                border-color: ${color("common.ui2")};
                color: ${color("common.ui2")};
                background-color: ${color("common.white")};
            }
        `,
    },
    tertiary: {
        ...ButtonPresentationPropsDefault,
        color: "transparent",
        buttonType: "solid",
        css: css`
            outline: none;
            border-color: ${color("transparent")};
            color: ${color("primary")};
            &:hover:not(:disabled) {
                border-color: ${color("transparent")};
                color: ${color("common.ui1")};
            }
            &:disabled {
                opacity: 0.5;
                box-shadow: none;
                border-color: ${color("transparent")};
                color: ${color("primary", 0.33)};
                background: transparent;
            }
            &:focus:not(:disabled),
            &:active:not(:disabled) {
                outline: none;
                border-color: ${color("transparent")};
                color: ${color("common.ui2")};
            }
            &.no-padding {
                padding: 0;
            }
        `,
    },
} as xBaseTheme["button"];
